import { DisciplineOptions, FrequencyTypeEnum, FrequencyTypeOptions } from '@generated';
import { AutocompleteSearchField } from '~/shared/forms/controls/base-fields/AutocompleteSearchField';
import { DateTimeField } from '~/shared/forms/controls/base-fields/DateTimeField';
import { useEditFrequencies } from './EditFrequenciesContext';
import { Button } from '~/shared/components/buttons/Button';
import { X } from 'lucide-react';

export function EditFrequenciesList() {
	const {
		wizardState: { draftEvaluations, draftRoutineFrequencies },
		dispatch
	} = useEditFrequencies();

	const rows = [
		...draftEvaluations.map(x => ({ ...x, frequencyTypeId: FrequencyTypeEnum.Evaluation })),
		...draftRoutineFrequencies.map(x => ({ ...x, frequencyTypeId: FrequencyTypeEnum.Routine }))
	];

	if (rows.length === 0) {
		return <p className="text-gray-500">No frequencies have been added.</p>;
	}

	const disciplines = DisciplineOptions.filter(d => rows.some(r => r.disciplineId === d.id));

	return (
		<div className="space-y-6">
			{disciplines.map(discipline => (
				<div key={discipline.id} className="space-y-2">
					<span className="font-medium text-gray-900">{discipline.label}</span>
					{rows
						.filter(r => r.disciplineId === discipline.id)
						.sort((a, b) => a.scheduledDateAndTime.getTime() - b.scheduledDateAndTime.getTime())
						.map(row => (
							<div key={row.id} className="flex items-center justify-between gap-2 rounded border border-gray-300 bg-gray-50 p-2">
								<div className="flex flex-1 items-center gap-4">
									<span className="w-24 font-medium text-gray-900">
										{FrequencyTypeOptions.find(x => x.id === row.frequencyTypeId)!.label}
									</span>
									<DateTimeField
										value={row.scheduledDateAndTime}
										onChange={value =>
											dispatch({
												type: 'LIST_UPDATE_DRAFT_FREQUENCY',
												frequencyId: row.id,
												scheduledDateAndTime: value!,
												assignedToId: row.assignedToId
											})
										}
										granularity="minute"
										label="Scheduled Date/Time"
										hideLabel
									/>
								</div>
								<AutocompleteSearchField
									searchType="user"
									label="Assigned To"
									hideLabel
									placeholder="Assign to user..."
									value={row.assignedToId ?? null}
									onChange={value =>
										dispatch({
											type: 'LIST_UPDATE_DRAFT_FREQUENCY',
											frequencyId: row.id,
											scheduledDateAndTime: row.scheduledDateAndTime,
											assignedToId: value ?? undefined
										})
									}
								/>
								<Button
									Icon={X}
									appearance="outline"
									intent="destructive"
									onClick={() => dispatch({ type: 'LIST_REMOVE_DRAFT_FREQUENCY', frequencyId: row.id })}
									aria-label="Remove Frequency"
								/>
							</div>
						))}
				</div>
			))}
		</div>
	);
}
